import * as React from "react";
import {IndexOrganization} from "../../../component/admin/organization/IndexOrganization";
import {CoreConstant} from "../../../core/utility/CoreConstant";

interface IProps {
    componentName?: string;
}

export class VillageOrganization extends React.Component<IProps> {

    constructor(props: IProps){
        super(props)
    }

    public render() {
        return (
            <IndexOrganization pageId={'VillageOrganization'} pageName={'Organisasi Desa'} category={CoreConstant.OrganizationStatus.Village} isMultipleLeader={false} />
        );
    }
}


// WEBPACK FOOTER //
// ./src/screen/admin/organization/VillageOrganization.tsx